import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

export function usePageSeo(pageKey: string) {
  const { data } = useQuery({
    queryKey: ["page_seo", pageKey],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("page_seo")
        .select("*")
        .eq("page_key", pageKey)
        .maybeSingle();
      if (error) throw error;
      return data;
    },
    staleTime: 1000 * 60 * 10,
  });

  useEffect(() => {
    if (!data) return;

    if (data.meta_title) document.title = data.meta_title;

    const setMeta = (name: string, content: string | null, property = false) => {
      if (!content) return;
      const attr = property ? "property" : "name";
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.content = content;
    };

    setMeta("description", data.meta_description);
    setMeta("keywords", data.meta_keywords);
    setMeta("og:title", data.meta_title, true);
    setMeta("og:description", data.meta_description, true);
    setMeta("og:image", data.og_image_url, true);

    if (data.canonical_url) {
      let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
      if (!link) {
        link = document.createElement("link");
        link.rel = "canonical";
        document.head.appendChild(link);
      }
      link.href = data.canonical_url;
    }
  }, [data]);
}
